export default __webpack_public_path__ + "static/policy3-ba6eacda686e1c4875325093d63c9744.png";